import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';

interface AutoRedirectProps {
  to?: string;
  delayMs?: number;
}

/**
 * Counts down and redirects to `to` (default: "/") after `delayMs` ms (default: 5000).
 * Drop inside any error state to give users a graceful exit.
 */
export function AutoRedirect({ to = '/', delayMs = 5000 }: AutoRedirectProps) {
  const [, navigate] = useLocation();
  const [seconds, setSeconds] = useState(Math.round(delayMs / 1000));

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(s => Math.max(0, s - 1));
    }, 1000);

    const timeout = setTimeout(() => {
      navigate(to);
    }, delayMs);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [to, delayMs, navigate]);

  return <p className="text-sm text-muted-foreground">Redirecting to home in {seconds}s…</p>;
}
